<template>
  <div>
    <a-collapse v-model="activeKey" expand-icon-position="right" class="variant-collapse">
      <a-collapse-panel :key="`${itemIndex}`">
        <template slot="header">
          <div @click="onStop">
            <a-row :gutter="16">
              <a-col :span="15">
                <a-row :gutter="16">
                  <a-col v-for="(opt, idx) in item.option" :key="idx" :span="8">
                    {{ opt }}
                  </a-col>
                </a-row>
              </a-col>
              <a-col :span="6">
                {{ item.sku ? item.sku : '-' }}
              </a-col>
              <a-col :span="3">
                <a-switch v-model="item.status" size="small" />
              </a-col>
            </a-row>
          </div>
        </template>
        <a-row :gutter="16">
          <a-col :span="5">
            <a-form-model-item :prop="'catalogs.items.' + itemIndex + '.images'" :rules="{ type: 'array', required: true, message: 'Pilih minimal 1 gambar produk', trigger: 'change' }">
              <div class="catalog-image" :disabled="isLoading" @click="onChooseImage">
                <img v-if="item.images.length" :src="item.images[0].preview" />
                <div v-else class="image-list">
                  <a-icon type="plus" />
                  <div class="ant-upload-text">
                    Pilih Gambar Produk
                  </div>
                </div>
              </div>
            </a-form-model-item>
          </a-col>
          <a-col :span="19">
            <a-row :gutter="16">
              <a-col :span="8">
                <a-form-model-item
                  label="SKU"
                  :prop="'catalogs.items.' + itemIndex + '.sku_exist'"
                  :rules="{ validator: validateSku, trigger: 'blur' }"
                >
                  <a-spin :spinning="item.loading">
                    <a-input
                      v-model="item.sku"
                      size="large"
                      :disabled="isLoading || item.loading"
                      @change="event => item.sku = event.target.value.toUpperCase()"
                      @blur="onCheckSku($event, itemIndex)"
                    />
                  </a-spin>
                  <a-input v-model="item.sku_exist" style="display: none" />
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item :label="$t('product.factory_sku')" :prop="'catalogs.items.' + itemIndex + '.factory_sku'">
                  <a-input
                    v-model="item.factory_sku"
                    size="large"
                    :disabled="isLoading"
                  />
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item :label="$t('product.barcode')" :prop="'catalogs.items.' + itemIndex + '.barcode'">
                  <a-input
                    v-model="item.barcode"
                    size="large"
                    :disabled="isLoading"
                    @change="event => item.barcode = event.target.value.toUpperCase()"
                  />
                </a-form-model-item>
              </a-col>
              <a-col :span="24">
                <a-form-model-item
                  class="mt-3"
                  :prop="'catalogs.items.' + itemIndex + '.price.value'"
                  :rules="[{ required: true, message: 'Harga harus diisi', trigger: 'blur' }]"
                >
                  <a-input-group size="large" class="variant-price" compact>
                    <div class="addon-before">
                      {{ currency }}
                    </div>
                    <InputNumber
                      v-if="item.price.currency === 'IDR'"
                      v-model="priceLabel"
                      style="width: 370px"
                      :disabled="isLoading"
                      @blur="onBlurPrice($event, itemIndex)"
                    />
                    <InputNumberDecimal
                      v-else
                      v-model="priceLabel"
                      style="width: 370px"
                      :disabled="isLoading"
                      @blur="onBlurPrice($event, itemIndex)"
                    />
                    <a-input v-model="item.price.value" style="display: none;" />
                    <a-select
                      v-model="item.price.uom"
                      class="variant-uom"
                      style="width: 125px"
                      :disabled="isLoading"
                      @change="onChangeUom($event, itemIndex)"
                    >
                      <div slot="dropdownRender" slot-scope="menu">
                        <v-nodes :vnodes="menu" />
                        <a-divider style="margin: 2px 0;" />
                        <div class="btn-uom" @mousedown="e => e.preventDefault()" @click="$emit('addUom')">
                          Tambah Satuan
                        </div>
                      </div>
                      <a-select-option v-for="unit in uomList" :key="unit" :value="unit">
                        {{ unit }}
                      </a-select-option>
                    </a-select>
                  </a-input-group>
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </a-collapse-panel>
    </a-collapse>

    <a-modal
      :visible="isImageModalVisible"
      :width="550"
      :closable="false"
      title="Pilih Foto"
      class="modal-image"
      centered
    >
      <template slot="footer">
        <a-button
          key="back"
          size="large"
          @click="onCloseImageModal"
        >
          Batal
        </a-button>
        <a-button
          key="submit"
          size="large"
          type="primary"
          :disabled="!selectedImages.length"
          @click="onSubmitImage"
        >
          OK
        </a-button>
      </template>
      <a-checkbox-group v-model="selectedImages" class="image-list">
        <template v-for="(image, index) in imageList">
          <a-checkbox v-if="image.preview" :key="index" :value="index" @change="onSelectImage($event, index)">
            <img :src="image.preview" />
            <div v-if="image.order" class="image-order">
              {{ image.order }}
            </div>
          </a-checkbox>
        </template>
      </a-checkbox-group>
    </a-modal>
  </div>
</template>

<script>
import InputNumber from '@/components/Input/InputNumber.vue'
import InputNumberDecimal from '@/components/Input/InputNumberDecimal.vue'

export default {
  name: 'MultiVariant',
  components: {
    InputNumber,
    InputNumberDecimal,
    VNodes: {
      functional: true,
      render: (h, ctx) => ctx.props.vnodes,
    },
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
    itemId: {
      type: Number,
      default: 0,
    },
    images: {
      type: Array,
      default: () => [],
    },
    currency: {
      type: String,
      default: 'IDR',
    },
    uom: {
      type: Array,
      default: () => [],
    },
    validateSku: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      isImageModalVisible: false,
      priceLabel: 0,
      activeKey: [`${this.itemId}`],
      imageList: [],
      imageOrder: 1,
      selectedImages: [],
      prevSelectedImages: [],
    }
  },
  computed: {
    item: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      },
    },
    isLoading() {
      return this.loading
    },
    itemIndex() {
      return this.itemId
    },
    uomList() {
      return this.uom
    },
  },
  watch: {
    itemId(id) {
      this.activeKey = [id]
    },
    images: {
      handler: function(value) {
        let newImageOrder = 1
        let newImageList = []
        let newSelectedImages = []
        let newItemImages = []

        value.forEach(img => {
          if (img.preview) {
            newImageList.push({
              id: img.uid,
              name: img.name,
              preview: img.preview,
            })
          }
        })

        this.item.images.forEach(image => {
          const imgIndex = newImageList.findIndex(img => img.id == image.id)
          if (imgIndex > -1) {
            newImageList[imgIndex].order = newImageOrder
            newSelectedImages.push(imgIndex)
            newItemImages.push({
              ...newImageList[imgIndex],
              imageOrder: imgIndex,
            })
            newImageOrder++
          }
        })

        this.imageList = newImageList
        this.selectedImages = newSelectedImages
        this.prevSelectedImages = newSelectedImages
        this.item.images = newItemImages
        this.imageOrder = newImageOrder
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    onChooseImage() {
      if (!this.imageList.length) {
        this.$emit('upload', true)
      } else {
        this.isImageModalVisible = true
      }
    },
    onSelectImage(event, index) {
      this.imageList[index].order = event.target.checked
        ? this.imageOrder
        : null
      if (!event.target.checked) {
        this.imageOrder = 1
        this.selectedImages.forEach(imageIndex => {
          if (index != imageIndex) {
            this.imageList[imageIndex].order = this.imageOrder
            this.imageOrder++
          }
        })
      } else {
        this.imageOrder++
      }
    },
    onSubmitImage() {
      this.isImageModalVisible = false
      this.item.images = []
      this.prevSelectedImages = []
      this.selectedImages.forEach(imageIndex => {
        this.item.images.push({
          ...this.imageList[imageIndex],
          imageOrder: imageIndex,
        })
        this.prevSelectedImages.push(imageIndex)
      })
      this.$emit('validate', `catalogs.items.${this.itemIndex}.images`)
    },
    onCloseImageModal() {
      this.isImageModalVisible = false
      this.imageOrder = 1
      this.prevSelectedImages.forEach(imageIndex => {
        this.imageList[imageIndex].order = this.imageOrder
        this.imageOrder++
      })
      this.selectedImages = [...this.prevSelectedImages]
    },
    onCheckSku(event, index) {
      this.$emit('checksku', { sku: event.target.value?.toUpperCase(), index })
    },
    onChangeSymbol(value, index) {
      this.priceLabel = 0
      this.item.price.value = 0
      this.$emit('validate', `catalogs.items.${index}.price.value`)
    },
    onBlurPrice(value, index) {
      this.item.price.value = value
      this.$emit('validate', `catalogs.items.${index}.price.value`)
    },
    onChangeUom(value, index) {
      this.$emit('changeUom', { index, value })
    },
    onStop(e) {
      e.stopPropagation()
    },
  },
}
</script>

<style lang="scss">
.select-variant .ant-select-selection__rendered {
  line-height: 38px !important;
}

.variant-header {
  padding: 12px 16px;
  border: 1px solid #ccc;
  background-color: #fafafa;
}

.variant-collapse {
  background-color: white !important;
  border: none !important;
}

.variant-collapse > .ant-collapse-item {
  margin-top: 20px;
  border: 1px solid #e4e9f0 !important;
}

.variant-collapse .ant-collapse-content {
  background-color: #f0f2f4 !important;
}

.modal-image .ant-modal-body {
  padding-bottom: 0 !important;
}

.catalog-image {
  width: 140px;
  height: 140px;
  text-align: center;
  background: #fff;
  border: 1px solid #dedede;
  border-radius: 6px;
  cursor: pointer;

  img {
    width: 140px;
    height: 140px;
    margin: 0 auto;
    border-radius: 8px;
    object-fit: contain;
  }

  div {
    i {
      margin-top: 25px;
      font-size: 32px;
      color: #999;
    }

    .ant-upload-text {
      margin-top: 8px;
      color: #999;
      line-height: normal;
    }
  }
}

.image-list {
  margin-bottom: 15px !important;

  .ant-checkbox-wrapper {
    position: relative;
    width: 110px;
    height: 110px;
    margin: 0 15px 15px 0 !important;
    border: 1px solid #dedede;
    border-radius: 6px;
    cursor: pointer;

    .ant-checkbox {
      display: none;
    }

    &.ant-checkbox-wrapper-checked {
      border-color: #FF0A54;
    }

    span {
      margin: 0;
      padding: 0;
    }

    img {
      width: 108px;
      height: 108px;
      border-radius: 6px;
      object-fit: contain;
    }
  }

  .ant-checkbox::after,
  .ant-checkbox-input,
  .ant-checkbox-inner {
    display: none !important;
  }
}

.image-order {
  position: absolute;
  width: 20px;
  height: 20px;
  padding: 4px;
  top: 0;
  right: 0;
  font-size: 12px;
  line-height: 1;
  text-align: center;
  color: #fff;
  background: #FF0A54;
  border-top-right-radius: 4px;
}
</style>